/**
 * Progressbar (Epic C-4 — Bezetting & conflicten, Story C-4.1, UX-C4)
 *
 * Lichte, lokale `role="progressbar"`-component — er bestaat geen shadcn/
 * Radix-progressbar in deze codebase (AD-18, geen nieuwe UI-dependency).
 *
 * AD-13 (bindend): benutting is ALTIJD neutraal-informatief — navy-vulling
 * (`#2F5A7A`) op `#E2E8F0`, nooit een foutkleur, ook niet bij 0% of 100%.
 * Dit component accepteert daarom bewust GEEN kleur-prop — er is precies één
 * toegestane visuele staat.
 */

interface ProgressbarProps {
  /** Ingedeelde dagdelen. */
  value: number;
  /** Beschikbare dagdelen. */
  max: number;
  /** Zichtbaar tekstlabel naast de balk (AC 4: aantallen ALTIJD als tekst, nooit alleen balklengte). */
  label: string;
  ariaLabel: string;
  'data-testid'?: string;
}

const NAVY = '#2F5A7A';
const TRACK = '#E2E8F0';

export function Progressbar({ value, max, label, ariaLabel, 'data-testid': testId }: ProgressbarProps) {
  const percent = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;

  return (
    <div className="flex items-center gap-2">
      <div
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
        aria-label={ariaLabel}
        data-testid={testId}
        className="flex-1 h-2 rounded-full overflow-hidden"
        style={{ backgroundColor: TRACK }}
      >
        <div data-testid="progressbar-fill" className="h-full rounded-full transition-[width]" style={{ width: `${percent}%`, backgroundColor: NAVY }} />
      </div>
      <span className="text-xs text-[#1E293B] whitespace-nowrap">{label}</span>
    </div>
  );
}
